import ScreenshotButton from './ModelScreenshot'

export function DebugUtils() {
    return (
        <>
          <ScreenshotButton />
        </>
    )
}